import {
  DocumentNode,
  OperationVariables,
  QueryHookOptions,
  TypedDocumentNode,
  useQuery,
} from '@apollo/client';
import { useAuth } from 'context/auth';

export function useQueryWhenAuthed<
  TData = any,
  TVariables = OperationVariables
>(
  query: DocumentNode | TypedDocumentNode<TData, TVariables>,
  // @ts-expect-error FIXME: TS2344 - strict mode migration
  options: QueryHookOptions<TData, TVariables> = Object.create(null)
) {
  const { isLoggedIn, isLoading } = useAuth();
  // @ts-expect-error FIXME: TS2344 - strict mode migration
  return useQuery<TData, TVariables>(query, {
    ...options,
    skip: isLoading || !isLoggedIn || options.skip,
  });
}
